import { render, staticRenderFns } from "./SellerSignup.vue?vue&type=template&id=6446ff45&scoped=true"
import script from "./SellerSignup.vue?vue&type=script&lang=js"
export * from "./SellerSignup.vue?vue&type=script&lang=js"
import style0 from "./SellerSignup.vue?vue&type=style&index=0&id=6446ff45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446ff45",
  null
  
)

export default component.exports